import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-oltport-res-spec-table',
  templateUrl: './oltport-res-spec-table.component.html',
  styleUrls: ['./oltport-res-spec-table.component.scss']
})
export class OLTPortResSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'totalPorts', 'occupancy', 'OLTPort-oltPort'];
    super.onInit();
  }
}
